<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Add Item</h4>
      </div>
      <div class="modal-body">
        <div class="row mb-3">
          <div class="col-sm-6">
            <div class="form-group">
              <label>Name</label>
              <input class="form-control" [(ngModel)]="name" placeholder="Item name" type="text">
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label>IAP ID</label>
              <input class="form-control" [(ngModel)]="iapId" placeholder="com.example.item" type="text">
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-6">
            <div class="form-group">
              <label>Price</label>
              <input class="form-control" [(ngModel)]="price" placeholder="2.49" type="number" step="0.01" min="0">
            </div>
          </div>
          <div class="col-sm-6 d-flex align-items-end">
            <div class="form-check mb-1">
              <input class="form-check-input" type="checkbox" [(ngModel)]="isPack" id="isPackAdd">
              <label class="form-check-label" for="isPackAdd">Is Pack</label>
            </div>
          </div>
        </div>

        <hr/>
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h6 class="mb-0">Rewards</h6>
          <button type="button" class="btn btn-sm btn-success" (click)="addReward()">
            <i class="fa fa-plus"></i> Add Reward
          </button>
        </div>
        @for (reward of rewards; track $index; let i = $index) {
          <div class="card mb-2">
            <div class="card-body">
              <div class="d-flex justify-content-end mb-2">
                <button type="button" class="btn btn-sm btn-danger" (click)="removeReward(i)"><i class="fa fa-trash"></i></button>
              </div>
              <div class="row">
                <div class="col-sm-6 mb-2">
                  <label>Currency Type</label>
                  <select class="form-control" [(ngModel)]="reward.currencyType">
                    @for (ct of currencyTypes; track ct[1]) {
                      <option [ngValue]="ct[1]">{{ ct[0] }}</option>
                    }
                  </select>
                </div>
                <div class="col-sm-6 mb-2">
                  <label>Currency Quantity</label>
                  <input class="form-control" [(ngModel)]="reward.currencyQuantity" type="number" min="0">
                </div>
                <div class="col-sm-6 mb-2">
                  <label>Ticket Cost</label>
                  <input class="form-control" [(ngModel)]="reward.currencyTicketCost" type="number" min="0">
                </div>
                <div class="col-sm-6 mb-0">
                  <label>Increase Percent</label>
                  <input class="form-control" [(ngModel)]="reward.currencyIncreasePercent" type="number" min="0">
                </div>
              </div>
            </div>
          </div>
        }
        @if (rewards.length === 0) {
          <p class="text-muted small">No rewards added.</p>
        }
      </div>
      <div class="modal-footer">
        <button [disabled]="isLoading" type="button" class="btn btn-secondary" (click)="modal.hide()">Cancel</button>
        <button [disabled]="isLoading" type="button" class="btn btn-primary" (click)="save()">
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
          Add
        </button>
      </div>
    </div>
  </div>
</div>
